"use strict";
APP.game.AnimalObject = function ( p_type, p_objLevel ) {

    // Invoke (needed)
    EHDI.aka.Container.call( this );

    // Properties

    var HOLD_LIMIT = 2;


    // ** Parent (This reference)
    var _parent = this;

    // ** Level Reference
    var _objLevel;

    // ** General Values
    var _deltaAI, _direction, _initialPos, _isCaged, _isCageCorrect, _isDraggable, _isDragging, _isPaused, _state, _prevTouch, _type;

    // ** Graphics
    var _sprAnimal, _timelineMove, _isHidden, _isProwling, _hideTimer, _prowlPhase, _isScared, _finalXDest, _isExitingCage;
    var _animalSpeed = APP.config.stageWidth / 20;
    var LION_VISION = 250;
    var DOUBLE_CLICK_TIMEOUT = 250;
    var _clickCounter;

    // Private Methods

    // ** General Methods

    /**
     * Get position limits.
     */
    var _getPositionLimits = function () {

        var result;

        if ( _parent ) {

            result = {
                minX: ( _parent.width * 0.5 ),
                maxX: APP.config.stageWidth - ( _parent.width * 0.5 ),
                minY: _parent.height + 175,
                maxY: APP.config.stageHeight,
            };
        }

        return result;
    };

    /**
     * Set direction.
     * @param {*Number} p_value The new direction
     */
    var _setDirection = function ( p_value ) {

        if ( p_value !== -1 &&
            p_value !== 1 ) throw "Invalid value for direction." + p_value;
        
        _direction = p_value;
        
        // Set scale x accoring to direction
        if ( _sprAnimal ) _sprAnimal.scale.x = _direction;
    };

    // Randomize delta ai
    var _randomizeDeltaAI = function () {

        _deltaAI = Math.round( EHDI.NumberUtil.randomRange( APP.game.AnimalConfig.MIN_DELTA_AI, APP.game.AnimalConfig.MAX_DELTA_AI ) ) * 1000;
    };

    var _randomizeDuration = function () {

        var result = Math.round( EHDI.NumberUtil.randomRange( APP.game.AnimalConfig.MIN_MOVE_SPEED, APP.game.AnimalConfig.MAX_MOVE_SPEED ) );

        return result;
    }

    var _addMove = function (  p_posX, p_posY, p_callback, p_startMove, p_duration ) {

        if ( !_timelineMove ) _timelineMove = new TimelineMax();

        // Get limits
        var limits = _getPositionLimits();
        
        // Constrain to limits
        var posX = EHDI.NumberUtil.clamp( p_posX, limits.minX, limits.maxX );
        var posY = EHDI.NumberUtil.clamp( p_posY, limits.minY, limits.maxY );

        var duration = p_duration|| _randomizeDuration();
       
        // Add to timeline
        _timelineMove.to( _parent,  duration, 
            { 
                x: posX, 
                y: posY, 
                onStart: function () {

                     // Check if to change directions
                    if ( posX > _parent.x && _direction === -1 ) _setDirection( 1 );
                    else if ( posX < _parent.x && _direction === 1 ) _setDirection( -1 );
                    else if ( posX == _parent.x ) _setDirection( _direction );
                
                },
                onComplete: function () {

                    if ( p_callback ) p_callback();

                }, ease:Power0.easeNone
            } );

        if ( p_startMove === true ) _timelineMove.play();
    };

    var _setState = function ( p_state ) {

        // Check if values are the same, then return
        if ( _state === p_state ) return;

        // Set state
        _state = p_state;

        // Do according to state
        switch ( _state ) {

            case APP.game.AnimalState.IDLE:
            if(Math.random() < 0.8)
                {
                _parent.armature.animation.gotoAndPlay(_parent.animList[0], -1, -1, 0);
                var randomizedTime = Math.floor(Math.random()* 1000);
                _parent.armature.advanceTime(randomizedTime);
                }
            else
                _parent.armature.animation.gotoAndPlay(_parent.animList[3], -1, -1, 0);

                // Remove move tweens here
                if ( _timelineMove ) {
                    _timelineMove.stop();
                    _timelineMove.kill();
                }
                _timelineMove = null;
                _isScared = false;
                

                // Randomize delta AI
                _randomizeDeltaAI();

            break;

            case APP.game.AnimalState.MOVE: 
            if(_type !== APP.game.AnimalType.LION) 
                {
                    if(_isScared)    
                        _parent.armature.animation.gotoAndPlay(_parent.animList[4], -1, -1, 0);
                    else
                        _parent.armature.animation.gotoAndPlay(_parent.animList[1], -1, -1, 0);
                }
            else
                {
                    _parent.armature.animation.gotoAndPlay(_parent.animList[0], -1, -1, 0);
                }

                // Check if tweens are active, then throw error
                if ( _timelineMove ) throw "Tween is active when state is set to MOVE.";

                if (_type !== APP.game.AnimalType.LION ) 
                {


                    // Initialize values
                    var spawnArea = null;
                    var randSpawn = null;
                    


                        // Do according to isCaged
                        if ( _isCaged === true ) {
                            _isExitingCage = true;
                            // Add move to exit
                            _addMove( APP.config.stageWidth * 0.5, 
                                    _parent.y );

                            // Add move to spawn
                            // ** Set position to random spawn
                            // ** Get random spawn area
                            // randSpawn = Math.round( EHDI.NumberUtil.randomRange( 1, 2 ) );
                            // if ( randSpawn === 1 ) spawnArea = _objLevel.spawnBottom;
                            // else if ( randSpawn === 2 ) spawnArea = _objLevel.spawnTop;

                            spawnArea = _objLevel.spawnBottom;

                            // **Randomize position ( y-only )
                            _addMove( APP.config.stageWidth * 0.5, 
                                        EHDI.NumberUtil.randomRange( spawnArea.y, spawnArea.y + spawnArea.height ),
                                        function()
                                        {
                                            _isExitingCage = false;
                                        }
                                     );
                            
                            // Add move within spawn area
                            _addMove( EHDI.NumberUtil.randomRange( spawnArea.x, spawnArea.x + spawnArea.width ),
                                        EHDI.NumberUtil.randomRange( spawnArea.y, spawnArea.y + spawnArea.height ), 
                                        function () {
                                            // Set state to idle
                                            _setState( APP.game.AnimalState.IDLE );
                                        }, true );
                            
                        }
                        else if ( _isCaged === false ) {

                            // Move in spawn area or go to spawn area
                            if ( _objLevel ) {

                                // // Initialize needed vaulues
                                // var boundsAnimal = _parent.getBounds();
                                // var boundsSpawnBottom = _objLevel.spawnBottom.getBounds();
                                // var boundsSpawnTop = _objLevel.spawnTop.getBounds();

                                // // If collides with top spawn, set spawn area to top
                                // // If collides with bottom spawn, set spawn area to bottom
                                // if ( EHDI.CollisionUtil.rectToRect( boundsSpawnTop, boundsAnimal ) ) spawnArea = _objLevel.spawnTop;
                                // else if ( EHDI.CollisionUtil.rectToRect( boundsSpawnBottom, boundsAnimal ) ) spawnArea = _objLevel.spawnBottom;
                                // else {
                                //     // ** Get random spawn area
                                //     randSpawn = Math.round( EHDI.NumberUtil.randomRange( 1, 2 ) );
                                //     if ( randSpawn === 1 ) spawnArea = _objLevel.spawnBottom;
                                //     else if ( randSpawn === 2 ) spawnArea = _objLevel.spawnTop;
                                // }


                                spawnArea = _objLevel.spawnBottom;

                                //c = square root of [(xA-xB)^2+(yA-yB)^2]

                                var xDest = EHDI.NumberUtil.randomRange( spawnArea.x, spawnArea.x + spawnArea.width );
                                var yDest = EHDI.NumberUtil.randomRange( spawnArea.y, spawnArea.y + spawnArea.height );

                                var xDistSquared = Math.pow((_parent.x - xDest), 2);
                                var yDistSquared = Math.pow((_parent.y - yDest), 2);
                                var travelDist = Math.sqrt(xDistSquared + yDistSquared);

                                var speed= _animalSpeed;
                                if(_isScared)
                                    speed *= 9;
                                var duration = Math.abs(travelDist) / speed;
                                // Move
                                _addMove( xDest,
                                            yDest,
                                            function () { 
                                                _setState( APP.game.AnimalState.IDLE );
                                            }, true , duration);
                            
                            }
                        }
                }
            break;

            default:

                // Do nothing
        }
        
        // Dispatch event
        APP.managers.event.dispatch( APP.game.AnimalEvent.UPDATED_STATE, { obj: _parent } );
    };

    var _updateAI = function ( p_delta ) {

        if ( _state !== APP.game.AnimalState.IDLE ) return;

        if ( _isDragging ) return;

        if ( typeof _deltaAI !== "number" ) return;
        
        if (_type === APP.game.AnimalType.LION ) return;

        _deltaAI -= p_delta;


        if (( _deltaAI > 0 )) return;

        _setState( APP.game.AnimalState.MOVE );

        _randomizeDeltaAI();
    };

    var detectLion = function()
    {
        
        // if ( _state !== APP.game.AnimalState.IDLE ) return;

        if ( _isDragging ) return;

        if ( typeof _deltaAI !== "number" ) return;
        
        if (_type === APP.game.AnimalType.LION ) return;
        if ((!APP.game.lion) || (_isScared)) return;

        if(_isExitingCage) return;       

        var lionNear = false;
        if(APP.game.lion.isProwling)
        {
            var xDistSquared = Math.pow((_parent.x - APP.game.lion.x), 2);
            var yDistSquared = Math.pow((_parent.y - APP.game.lion.y), 2);
            var lionDistance = Math.sqrt(xDistSquared + yDistSquared);

            if(lionDistance <= LION_VISION)
                {
                    lionNear = true;
                    _isScared = true;
                }
        }
        

        if (lionNear)
            {
                _setState(APP.game.AnimalState.IDLE );
                _setState( APP.game.AnimalState.MOVE );
                _randomizeDeltaAI();
            }

    }

    // ** Handlers

    /**
     * Handler for frame update
     * @param {Number} p_delta 
     */
    var _handler_frameUpdate = function ( p_delta ) {
        
        if ( APP.game.btnPause ) {

            if ( APP.game.btnPause.isPaused === true || 
                APP.game.btnPause.isEndGame === true ) return;
        }
        
        if(_type === APP.game.AnimalType.LION)
            {
                if((_isHidden) && (!_isProwling))
                    {
                        _hideTimer -= p_delta

                        if(_hideTimer <= 0)
                            prowl();
                    }

            }


        
        // Do according to state
        if ( _state === APP.game.AnimalState.IDLE ) {

            detectLion();
            // Update ai
            _updateAI( p_delta );
        }
        else if ( _state === APP.game.AnimalState.MOVE ) {

            // Dispatch event on MOVE
            APP.managers.event.dispatch( APP.game.AnimalEvent.MOVING, { obj: _parent } );
        }

        if(_clickCounter > 0)
            {
                _clickTimer -= p_delta;

                if(_clickTimer <= 0)
                    {
                        _clickCounter = 0;
                    }
            }
    };

    /**
     * Handler for touch begin interaction.
     * @param {Pixi.interaction.InteractionEvent} e  The event dispatched
     */
    var _handler_touchBegin = function (e) {
        // var _handler_touchBegin = function ( e ) {
        
        // // Check if event values are valid
        // if ( !e ) return;
        // if ( !e.data ) return;

        // If not draggable, return
        if ( _isDraggable === false ) return;

        // If already dragging, return
        if ( _isDragging === true ) return;

        // If parent is empty return
        if ( !_parent ) return;

        if(APP.game.TouchObjects.count >= HOLD_LIMIT)  return;
        
        var propName = "interactId_"+e.data.identifier;

        if(APP.game.TouchObjects[propName]) return;

        APP.game.TouchObjects[propName] = _parent; 
        APP.game.TouchObjects.count++

        // Set isDragging to true
        _isDragging = true;


        if(_type !== APP.game.AnimalType.LION)
            {
                // Set state to idle
                _setState( APP.game.AnimalState.IDLE );

                _parent.armature.animation.gotoAndPlay(_parent.animList[2], -1, -1, 0);
                APP.managers.sound.playSFX("animal_pickup");
                APP.game.cages[_type-1].glow();

            }

        // Set initial position
        _initialPos = { x: _parent.x, y: _parent.y };
 
        // Set mouse/touch event data
        _prevTouch = {
            identifier: e.data.identifier,
            x: e.data.global.x,
            y: e.data.global.y,
        };
        
        // Dispatch event
        APP.managers.event.dispatch( APP.game.AnimalEvent.DRAG_START, { obj: _parent } );

        if (_type !== APP.game.AnimalType.LION )
            {
        // Snap to center of object
        _parent.x = ( e.data.global.x / APP.display.stage.scale.x );
        _parent.y = ( e.data.global.y / APP.display.stage.scale.y ) + ( ( _parent.height * _parent.scale.y ) * 0.5 );
            }
    };

    /**
     * Handler for touch move interaction.
     * @param {Pixi.interaction.InteractionEvent} e  The event dispatched
     */
    var _handler_touchMove = function (e ) {
        // var _handler_touchMove = function ( e ) {
        
        // // Check if event values are valid
        // if ( !e ) return;
        // if ( !e.data ) return;

        // If not draggable, return
        if ( _isDraggable === false ) return;

        // If not dragging, return
        if ( _isDragging === false ) return;

        // If touch data is empty, return
        if ( !_prevTouch ) return;
        
        // If current touch id is not equal to prev touch id, return
        // if ( e.data.identifier !== _prevTouch.identifier ) return;

        // If parent is empty return
        if ( !_parent ) return;
        
        if(_type === APP.game.AnimalType.LION)  return;

        // Initialize some values
        var currentTouch = e.data;
        
        var diffX = ( currentTouch.global.x - _prevTouch.x ) / APP.display.stage.scale.x;
        var diffY = ( currentTouch.global.y - _prevTouch.y ) / APP.display.stage.scale.y;
        
        if ( diffX === 0 && diffY === 0 ) return;

        // Set prev position
        _prevTouch.x = currentTouch.global.x;
        _prevTouch.y = currentTouch.global.y;
        
        // Snap to center
        _parent.x = ( currentTouch.global.x / APP.display.stage.scale.x );
        _parent.y = ( currentTouch.global.y / APP.display.stage.scale.y ) + ( ( _parent.height * _parent.scale.y ) * 0.5 );
        
        // Get limits
        var limits = _getPositionLimits();

        _parent.x = EHDI.NumberUtil.clamp( _parent.x, limits.minX, limits.maxX );
        _parent.y = EHDI.NumberUtil.clamp( _parent.y, limits.minY, limits.maxY );
    };

     /**
     * Handler for touch end interaction.
     * @param {Pixi.interaction.InteractionEvent} e  The event dispatched
     */
    var _handler_touchEnd = function ( e ) {
        // var _handler_touchEnd = function ( e ) {
        
        // // Check if event values are valid
        // if ( !e ) return;
        // if ( !e.data ) return;

        // If not draggable, return
        if ( _isDraggable === false ) return;

        // If not dragging, return
        if ( _isDragging === false ) return;

        // If touch data is empty, return
        if ( !_prevTouch ) return;

        
        var propName = "interactId_"+e.data.identifier;

        if(APP.game.TouchObjects[propName] != _parent)
                return;
        
        APP.game.TouchObjects[propName] = null;  
        APP.game.TouchObjects.count--;

        // // If current touch id is not equal to prev touch id, return
        // if ( e.data.identifier !== _prevTouch.identifier ) return;

        // If parent is empty return
        if ( !_parent ) return;

        // Set isDragging to false
        _isDragging = false;

        // Nullify prev touch data
        _prevTouch = null;

        // Dispatch event
        APP.managers.event.dispatch( APP.game.AnimalEvent.DRAG_END, { obj: _parent } );

        // Nullify initial position
        _initialPos = null;

  

        if(_type !== APP.game.AnimalType.LION)
            {      
                // Set state to idle
                _setState(null);
                _setState( APP.game.AnimalState.IDLE );       
                
                APP.game.cages[_type-1].glowFade();
            }

        _clickCounter++;
        _clickTimer = DOUBLE_CLICK_TIMEOUT;

        if(_clickCounter >= 2)
            {                
                if(_type  === APP.game.AnimalType.LION)
                {
                    APP.gameInstance.lionSparkle(_parent.x, _parent.y);
                    hide();
                }
            }
    };

    /**
     * Handler for animal drag start.
     * @param {Event} e The corresponding event. 
     */
    var _handlerAnimal_dragStart = function ( e ) {
       
        // Check if event values are valid
        if ( !e ) return;
        if ( !e.obj ) return;

        // If event object is equal to this instance, return
        if ( e.obj === _parent ) return;

        // If already not draggable, return
        if ( _isDraggable === false ) return;

        // If already dragging, return
        if ( _isDragging === true ) return;

        // Set isDraggable to false
        // _isDraggable = false;  
        
        // Set isDragging to false
        _isDragging = false;

        // Set prevTouch to false
        _prevTouch = null;

        // Nullify initial position
        _initialPos = null;
    };
 

    /**
     * Handler for animal drag end.
     * @param {Event} e The corresponding event. 
     */
    var _handlerAnimal_dragEnd = function ( e ) {

         // Check if event values are valid
        if ( !e ) return;
        if ( !e.obj ) return;

        // If event object is equal to this instance, return
        if ( e.obj === _parent ) return;

        // If already draggable, return
        if ( _isDraggable === true ) return;


        // Set isDraggable to true
        _isDraggable = true;
    };

    // ** Initialization Methods

    var _initProps = function ( p_type, p_objLevel ) {

        // Check if param value if not valid, then throw errpr
        if ( p_type !== APP.game.AnimalType.SHEEP && 
            p_type !== APP.game.AnimalType.GOAT &&
            p_type !== APP.game.AnimalType.LION) throw "Type value for animal is invalid.";

        if ( !p_objLevel ) throw "Level object reference for animal is invalid.";

        // Initialize properties
        _objLevel = p_objLevel;

        _type = p_type;
        _deltaAI = 0;
        _direction = null;
        _state = APP.game.AnimalState.IDLE;
        _initialPos = null;
        _isCaged = false;
        _isCageCorrect = false;
        _isDraggable = true;
        _isDragging = false;
        _isPaused = false;
        _prevTouch = null;
        _isScared = false;
        _isExitingCage = false;

        _isHidden = false;
        _isProwling = false;
        _hideTimer =0;

        _clickCounter = 0;
        _clickTimer = DOUBLE_CLICK_TIMEOUT;



        // Randomize delta ai
        _randomizeDeltaAI();
    };

    var _initGraphics = function () {

        // Set interactive to true
        _parent.interactive = true;

        // Initialize graphics
        if ( !_sprAnimal ) {

            // Get image according to 
            _sprAnimal = new EHDI.aka.Sprite();
            // _sprAnimal.anchor.set( 0.5, 1 );

            if(_type == 1)
                _parent.armature = EHDI.DBoneFactory.createArmature("goat_armature");
            else if(_type == 2)
                _parent.armature = EHDI.DBoneFactory.createArmature("sheep_armature");
            else
                _parent.armature = EHDI.DBoneFactory.createArmature("lion_armature");

            _parent.animationSprite = _parent.armature.getDisplay();
            _parent.animList = _parent.armature.animation.animationList;
            _parent.armature.animation.gotoAndPlay(_parent.animList[0], -1, -1, 0);
            var randomizedTime = Math.floor(Math.random()* 1000);
            _parent.armature.advanceTime(randomizedTime);
            _parent.animationSprite.scaleX = -1;
            _sprAnimal.addChild(  _parent.animationSprite );

           // Randomize direction
            var rand = Math.round( EHDI.NumberUtil.randomRange( 1, 2 ) );
            if ( rand === 1 ) _setDirection( -1 );
            else if ( rand === 2 ) _setDirection( 1 );
                      
            if ( _parent )_parent.addChild( _sprAnimal );
        }

        // Initialize tween properties
        _timelineMove = null;
    };

    var _initListeners = function () {

        // Add frame listeners
        APP.managers.update.addFrameListener( _handler_frameUpdate );

        // Add interaction listeners
        if ( _parent ) {

            if ( EHDI.BrowserInfo.isMobileDevice ) {
                _parent.on( "touchstart", _handler_touchBegin );
                // _parent.on( "touchmove", _handler_touchMove );
                _parent.on( "touchend", _handler_touchEnd );
                _parent.on( "touchcancel", _handler_touchEnd );
                _parent.on( "touchendoutside", _handler_touchEnd );
            }
            else {
                _parent.on( "mousedown", _handler_touchBegin );
                // _parent.on( "mousemove", _handler_touchMove );
                _parent.on( "mouseup", _handler_touchEnd );
                _parent.on( "mouseupoutside", _handler_touchEnd );
            }
        }

        // Add satelite listeners
        APP.managers.event.addListener( APP.game.AnimalEvent.DRAG_START, _handlerAnimal_dragStart );
        APP.managers.event.addListener( APP.game.AnimalEvent.DRAG_END, _handlerAnimal_dragEnd );
    };

    // ** Kill Methods

    var _killProps = function () {

        _parent = null;

        _objLevel = null;

        _deltaAI = null;
        _direction = null;
        _initialPos = null;
        _isCaged = null;
        _isCageCorrect = null;
        _isDraggable = null;
        _isDragging = null;
        _isPaused = null;
        _state = null;
        _type = null;
        _prevTouch = null;
    };

    var _killGraphics = function () {

        // Set interactive to false
        _parent.interactive = false;

        // ** Kill tweens
        if ( _timelineMove ) _timelineMove.kill();
        _timelineMove = null;

        if ( _sprAnimal ) {

            if ( _sprAnimal.parent ) _sprAnimal.parent.removeChild( _sprAnimal );

            _sprAnimal.destroy( { children: true } );
        }
        _sprAnimal = null;

        EHDI.DBoneFactory.destroyArmature(_parent.armature);
    };

    var _killListeners = function () {

        // Remove frame listeners
        APP.managers.update.removeFrameListener( _handler_frameUpdate );

        // Remove interaction listeners
        if ( _parent ) {

            if ( EHDI.BrowserInfo.isMobileDevice ) {

                _parent.off( "touchstart", _handler_touchBegin );
                // _parent.off( "touchmove", _handler_touchMove );
                _parent.off( "touchend", _handler_touchEnd );
                _parent.off( "touchcancel", _handler_touchEnd );
                _parent.off( "touchendoutside", _handler_touchEnd );
            }
            else {

                _parent.off( "mousedown", _handler_touchBegin );
                // _parent.off( "mousemove", _handler_touchMove );
                _parent.off( "mouseup", _handler_touchEnd );
                _parent.off( "mouseupoutside", _handler_touchEnd );
            }
        }

        // Remove satelite listeners
        APP.managers.event.removeListener( APP.game.AnimalEvent.DRAG_START, _handlerAnimal_dragStart );
        APP.managers.event.removeListener( APP.game.AnimalEvent.DRAG_END, _handlerAnimal_dragEnd );
    };

    // Public Methods

    this.destroy = function () {
        
        // Kill listeners
        _killListeners();

        // Kill graphics
        _killGraphics();

        // Kill props
        _killProps();

        // Call superclass method
        APP.game.AnimalObject.prototype.destroy.apply( this, arguments );
    };


    var hide = function()
    {
        if(_type !== APP.game.AnimalType.LION)
            return;
        
        _setState( null );
        _setState( APP.game.AnimalState.IDLE );

        if(Math.random() < 0.5)
            _parent.x = -50 - _parent.width;
        else
            _parent.x = APP.config.stageWidth +50 + _parent.width;

        _parent.y = APP.config.stageHeight - (Math.random() * 25);
        _isHidden = true;
        _isProwling = false;
        _prowlPhase = 0;
        _hideTimer = EHDI.NumberUtil.randomRange( 15000, 20000 );

        
        _finalXDest = 200;
        if(Math.random() < 0.5)
            _finalXDest = APP.config.stageWidth -200;
    }
    // this._hide = function(){ hide()};

    var prowl = function()
    {
        if(_type !== APP.game.AnimalType.LION)
            return;

        _setState( null );
        _setState( APP.game.AnimalState.IDLE );
        _setState( APP.game.AnimalState.MOVE );
        _isHidden = false;
        _isProwling = true;
        
        if(_prowlPhase == 0)
        {
            var xDestInit = 300;
            if(_parent.x > 512) //1024
                xDestInit = 700;

            _addMove( xDestInit, _parent.y,
                function()
                {
                    _prowlPhase++;
                    prowl();
                }
            , true,7.5);//, null, null, 10);

       
        }
        else if(_prowlPhase == 1)
        {
            var yDest = EHDI.NumberUtil.randomRange( 200, 250 );
            _addMove( APP.config.stageWidth * 0.5, yDest,
                function()
                {
                    _prowlPhase++;
                    prowl();
                }
            , true,5);
        }
        else if(_prowlPhase == 2)
        {
            // var xDest = 200;
            // if(Math.random() < 0.5)
            //     xDest = APP.config.stageWidth -200;
                
            _addMove( _finalXDest, _parent.y, 
                function () {
                    // Set state to idle
                    _setState( APP.game.AnimalState.IDLE );

                    // call game over
                    if(APP.gameOverCall)
                        APP.gameOverCall();
                }, true, 5 );
        }
    }
    this._prowl = function() {prowl()};

    // Call init methods
    _initProps( p_type, p_objLevel );
    _initGraphics();
    _initListeners();

    if(_type === APP.game.AnimalType.LION)
        {
            hide();
            _hideTimer = 30000;
        }

     Object.defineProperties( _parent, {
        "initialPosition": {
            get: function () { return _initialPos; },
            enumerable: true
        },
        "isCaged": {
            get: function () { return _isCaged; },
            set: function ( p_value ) { if ( _isCaged !== p_value  ) _isCaged = p_value; },
            enumerable: true
        },
        "isCageCorrect": {
            get: function () { return _isCageCorrect; },
            set: function ( p_value ) { if ( _isCageCorrect !== p_value  ) _isCageCorrect = p_value; },
            enumerable: true
        },
        "paused": {
            get: function () { return _isPaused; },
            set: function ( p_value ) {

                if ( p_value !== true &&
                    p_value !== false ) throw "Pause value should be boolean.";

                if ( _isPaused === p_value ) return;

                // Set isPaused
                _isPaused = p_value;
                
                if ( _isPaused === true ) {

                    if ( _timelineMove ) {

                        if ( _timelineMove.isActive() ) _timelineMove.pause();
                    }

                }
                else if ( _isPaused === false ) {

                    if ( _timelineMove ) {

                        if ( !_timelineMove.isActive() ) _timelineMove.play();
                    }
                }
                
            },
            enumerable: true
        },
        "state": {
            get: function () { return _state; },
            set: function ( p_val ) { _setState( p_val ); },
            enumerable: true
        },
        "type": {
            get: function () { return _type; },
            enumerable: true
        },
        "isProwling": {
            get: function () { return _isProwling; },
            enumerable: true
        },
        "hideTimer": {
            get: function () { return _hideTimer; },
            set: function ( p_value ) { _hideTimer = p_value; },
            enumerable: true
        },
    });

    _parent.interactMove = _handler_touchMove;

    // Return
    return _parent;

};
APP.game.AnimalObject.prototype = Object.create( EHDI.aka.Container.prototype );
APP.game.AnimalObject.prototype.constructor = APP.game.AnimalObject;